// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { LazyImageStyle } from "@conklin/MobiusOverrides/LazyImage";
import { LazyPictureStyle } from "@conklin/MobiusOverrides/LazyImage/LazyPicture";
import { imageStyles } from "@conklin/Overrides/Widgets/Basic/Image";
import IconArrowRight from "@conklin/XDL/Icons/IconArrowRight";
import { createLinkIconStyles, xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

imageStyles.contentWrapper = {
    css: css`
        position: absolute;
        top: 32px;
        left: 20px;
        display: flex;
        flex-direction: column;
        width: calc(100% - 40px);
    `,
};

imageStyles.contentMessage = {
    size: 16,
    lineHeight: "26px",
    color: "common.ui1",
    css: css`
        margin-bottom: 16px;
    `,
};

imageStyles.contentLink = {
    ...createLinkIconStyles(IconArrowRight, "default", "right", true, {
        css: css`
            align-self: flex-start;
        `,
    }),
};

imageStyles.wrapper = {
    css: css`
        ${({ fullWidthImage, fullHeightImage, maxHeight }: any) => {
            return css`
                ${fullWidthImage &&
                css`
                    &,
                    ${LazyImageStyle},${LazyPictureStyle}, &&& img {
                        width: 100%;
                    }
                `}
                ${fullHeightImage &&
                css`
                    &,
                    ${LazyImageStyle},${LazyPictureStyle}, &&& img {
                        height: 100%;
                    }
                `}
                ${maxHeight &&
                css`
                    &&& img {
                        max-height: max(${maxHeight + 64}px, 100%);
                        ${xScreen("lte", 767)} {
                            max-height: ${maxHeight + 64}px;
                        }
                    }
                `}
            `;
        }}
    `,
};
